module.exports = __webpack_public_path__ + "img/bg-login@2x.ad8e21ff.png";